import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { NgxsModule } from '@ngxs/store';
import { UserState } from '@app/modules/user/store/user.state';
import { UserRoutingModule } from '@app/modules/user/router';
import { UserModelFactory } from '@app/modules/user/factory/user-model.factory';
import { UserStorageService } from '@app/modules/user/service/user-storage.service';
import { UserHttpService } from '@app/modules/user/service/user-http.service';
import { UserSidebarComponent } from '@app/modules/user/part/user-sidebar/user-sidebar.component';
import { ChangePasswordComponent } from '@app/modules/user/part/change-password/change-password.component';
import { ChangeUserInfoComponent } from '@app/modules/user/part/change-user-info/change-user-info.component';

const imports = [
  SharedModule,
  UserRoutingModule,
  NgxsModule.forFeature([UserState]),
];

const declarations = [
  UserSidebarComponent,
  ChangePasswordComponent,
  ChangeUserInfoComponent,
];

const providers = [
  UserModelFactory,
  UserHttpService,
  UserStorageService,
];

@NgModule({
  imports,
  declarations,
  providers,
  exports: [...declarations]
})
export class UserModule { }
